<template>
    <div>
        <ExpireHeader header="ดูรายละเอียดสินค้า" :img_header="header_image" link_back="stock/storage/expirestorage"/>
        <Expire_details/>
    </div>
</template>

<script>
    import HeaderImage from '@/assets/loupe.png'
    import ExpireHeader from "@/components/admin/stock/storage_expire/header_expire/ExpireHeader.vue";
    import Expire_details from "@/components/admin/stock/storage_expire/Expire_details.vue";
    export default {
        name: "ExpireDetail",
        components: {
            Expire_details,
            ExpireHeader
        },
        data() {
            return {
                header_image: HeaderImage
            }
        }
    }
</script>

<style scoped>

</style>
